import { ResponseLiveInfo } from './responseLive';
import { ResponseUser } from './responseUser';

export interface ResponseListLiveMatch {
  found: number;
  liveMatches: Array<ResponseLiveMatch>;
}

export enum LiveCompetitionResult {
  Draw = 'draw',
  ByeWin = 'bye-win',
  Abstention = 'abstention',
  Win = 'win',
  Lose = 'lose',
}

export interface ResponseLiveMatch {
  createdBy: string;
  lastModifiedBy: string;
  createdDateTime: string;
  lastModifiedDateTime: string;
  id: string;
  live: ResponseLiveInfo;
  target: ResponseLiveInfo;
  liveId?: string;
  type: string;
  kind: string;
  status: string;
  message: string;
  readyTime: number;
  playingTime: number;
  keepTime: number;
  startDateTime: string;
  endDateTime: string;
}

export interface ResponseScoresLiveCompetitions {
  createdBy: string;
  createdDateTime: string;
  id: string;
  lastModifiedBy: string;
  lastModifiedDateTime: string;
  liveCompetitionId: string;
  result: LiveCompetitionResult;
  score: number;
  user: ResponseUser;
}
export interface ResponseLiveCompetitions {
  createdBy: string;
  lastModifiedBy: string;
  createdDateTime: string;
  lastModifiedDateTime: string;
  id: string;
  liveMatch: ResponseLiveMatch;
  liveMatchId: string;
  startDateTime: string;
  scores: Array<ResponseScoresLiveCompetitions>;
}
